import fetcher from './fetcher';

const api = {
  open: fetcher.get.bind(fetcher, '/open'),
  state: fetcher.get.bind(fetcher, '/state'),
};

export default api;
